module.exports = __webpack_public_path__ + "img/dz.04a6481d.svg";